"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportCSVButton = void 0;
const React = __importStar(require("react"));
const use_custom_compare_1 = require("use-custom-compare");
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const CSVUtils_1 = require("src/configeek_assets/src/system/mics/CSVUtils");
const BUTTON_LABEL__EXPORT_CSV = "Export CSV";
const ExportCSVButton = (props) => {
    const onClickExport = (0, use_custom_compare_1.useCustomCompareCallback)(async () => {
        CSVUtils_1.CSVUtils.prepareAndDownload(props.dataSource, props.identifier);
    }, [props], lodash_1.default.isEqual);
    return React.createElement(antd_1.Button, { onClick: onClickExport, icon: React.createElement(icons_1.ExportOutlined, { rotate: -90 }), size: props.size, disabled: props.disabled }, BUTTON_LABEL__EXPORT_CSV);
};
exports.ExportCSVButton = ExportCSVButton;
